import type { TextLocationBox } from '@avisoma/shared';

export function FieldBoxOverlay({
  boxes,
  pageWidth,
  pageHeight,
}: {
  boxes: TextLocationBox[];
  pageWidth: number;
  pageHeight: number;
}) {
  if (!boxes.length || pageWidth <= 0 || pageHeight <= 0) return null;
  return (
    <>
      {boxes.map((box, index) => (
        <div
          key={`${box.x}-${box.y}-${index}`}
          className="pointer-events-none absolute ring-2 ring-inset ring-blue-500 bg-blue-400/20"
          style={{
            left: `${(box.x / pageWidth) * 100}%`,
            top: `${(box.y / pageHeight) * 100}%`,
            width: `${(box.w / pageWidth) * 100}%`,
            height: `${(box.h / pageHeight) * 100}%`,
          }}
          aria-hidden
        />
      ))}
    </>
  );
}
